import { render, staticRenderFns } from "./i-markdown-editor.vue?vue&type=template&id=dd20fd0e&scoped=true&"
import script from "./i-markdown-editor.vue?vue&type=script&lang=js&"
export * from "./i-markdown-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20fd0e",
  null
  
)

export default component.exports